// src/pages/transactions/index.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../../core/api';
import '../factors/Factors.css';
import { METHOD_LABELS } from './TransactionForm';
import TransactionsSkeleton from './TransactionsSkeleton';

const Transactions = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deletingId, setDeletingId] = useState(null);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('success');

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get('/transactions');
        setItems(res.data?.transactions || []);
      } catch (err) {
        setMessage('خطا در دریافت تراکنش‌ها');
        setMessageType('danger');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  useEffect(() => {
    if (!message) return;
    const t = setTimeout(() => setMessage(''), 3000);
    return () => clearTimeout(t);
  }, [message]);

  const handleDelete = async (id) => {
    if (!window.confirm('این تراکنش حذف شود؟ موجودی مشتری اصلاح می‌شود.')) return;
    setDeletingId(id);
    try {
      await api.post(`/transactions/${id}/delete`);
      setItems((prev) => prev.filter((t) => t.id !== id));
      setMessage('تراکنش حذف شد');
      setMessageType('success');
    } catch (err) {
      setMessage(err.response?.data?.error || 'خطا در حذف');
      setMessageType('danger');
    } finally {
      setDeletingId(null);
    }
  };

if (loading) return <TransactionsSkeleton />;

  return (
    <>
      {message && (
        <div className={messageType === 'danger' ? 'toast-danger' : 'toast-success'}>
          {message}
        </div>
      )}

      <div className="card">
        <div className="card-header-row">
          <h2>تراکنش ها</h2>
          <Link className="btn" to="/dashboard/transactions/new">
            <i className="fa-solid fa-plus" /> تراکنش جدید
          </Link>
        </div>

        {items.length === 0 ? (
          <div className="empty">هنوز تراکنشی ثبت نشده است.</div>
        ) : (
          items.map((t) => {
            const isReceive = t.direction === 'receive';
            const who =
              t.method === 'charity'
                ? `خیریه: ${t.charity_name || '-'}`
                : t.customer_name || '-';
            const ref = t.tracking_no
              ? `پیگیری: ${t.tracking_no}`
              : t.cheque_serial
              ? `سریال چک: ${t.cheque_serial}`
              : '';

            return (
              <div className="list-item" key={t.id}>
                <div>
                  <div>
                    <b style={{ color: isReceive ? 'var(--success)' : 'var(--danger)' }}>
                      <i
                        className={`fa-solid ${
                          isReceive ? 'fa-arrow-down' : 'fa-arrow-up'
                        }`}
                        style={{ marginInlineEnd: 6 }}
                      />
                      {isReceive ? 'دریافت' : 'پرداخت'}
                    </b>{' '}
                    <span className="badge">{t.date}</span>{' '}
                    <span className="badge">{METHOD_LABELS[t.method]}</span>
                  </div>
                                 <div className="muted">
                    {who} — {Number(t.amount).toLocaleString('fa-IR')} ریال
                    {ref ? ` — ${ref}` : ''}
                    {t.bank_name ? ` — حساب: ${t.bank_name}` : ''}
                  </div>
                  {t.description && <div className="muted">{t.description}</div>}
                </div>
                <div className="row-actions">
                  <Link
                    className="btn secondary small"
                    to={`/dashboard/transactions/${t.id}/edit`}
                  >
                    <i className="fa-solid fa-pen" /> ویرایش
                  </Link>
                  <button
                    type="button"
                    className="btn danger small"
                    onClick={() => handleDelete(t.id)}
                    disabled={deletingId === t.id}
                  >
                    {deletingId !== t.id && <i className="fa-solid fa-trash" />}
                    {deletingId === t.id ? 'در حال حذف...' : 'حذف'}
                  </button>
                </div>
              </div>
            );
          })
        )}
      </div>
    </>
  );
};

export default Transactions;
